import React from 'react'

export default function NotFound() {
  return (
    <div>
        <div className="">
 <img className='mx-auto' src="https://i.ibb.co/q18XD2L/404.png" alt=""/>
  
  </div>
</div>
   
  )
}
